import { Injectable } from '@angular/core';
import { OrderFileterDetail } from '../../app/modules/chart/interface/interfaces';
import { Actions, AppStore } from '../index';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class OrderFilterActions extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public storeOrderFilter(
    filter: OrderFileterDetail
  ): ReduxAction<OrderFileterDetail> {
    return { type: ReduxType.OREDER_TABLE, payload: filter };
  }
}
